import { render } from "./BankIdModal.vue?vue&type=template&id=7a84f705"
import script from "./BankIdModal.vue?vue&type=script&lang=js"
export * from "./BankIdModal.vue?vue&type=script&lang=js"

import "./BankIdModal.vue?vue&type=style&index=0&id=7a84f705&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__